import { DeckColumn, KPIDrivers } from '@services/api/deckManagement/graphql/schema/API';
import { EnhancedDeckline } from 'types/DecklinesContext.types';
import { KpiDimension } from 'types/PageSidePanel.types';

export interface PageSectionMappingGroup {
  blocks: Record<string, Record<string, DeckColumn[]>>;
}

/**
 * Interface for constructing a Page Layout from DeckColumn and template information
 */
export interface PageLayout {
  pageSections: Record<string, PageSectionMappingGroup>;
}

/**
 * Helper type for Page & Deckline Driver Updates.
 */
export type PartialKPIDrivers = Partial<Omit<KPIDrivers, '__typename'>>;

/**
 * Enum for context menu options
 */
export enum ContextMenuEnums {
  INSERT_ROW = 'Insert Row', // Single Insert row appears when no Page Decklines yet exist
  INSERT_ROW_ABOVE = 'Insert Row Above',
  INSERT_ROW_BELOW = 'Insert Row Below',
  FOOTNOTES = 'Footnotes',
  COMMENT = 'Comment',
  DECKLINE_HISTORY = 'Deckline History',
  DELETE_DECKLINE = 'Delete Deckline',
  DISPLAY_NAME_OVERRIDE = 'Edit Display Name',
  // -- DEBUG OPTIONS --
  DEBUG_OUTPUT_DECKLINE = '[DEV] Deckline Console Debug', // Outputs deckline data directly to console (localhost dev only)
}

/**
 * Known granularity options for pages.
 */
export enum PageGranularity {
  MTD = 'MTD',
  QTD = 'QTD',
  YTD = 'YTD',
  Summary = 'Summary',
  Fx = 'Fx',
}

/**
 * Interface for the row data used in the Page Deckline view table.
 */
export interface DecklineRowData extends Record<KpiDimension, string | null> {
  id: number;
  rowNumber: string | number;
  kpi_name?: string | null;
  is_subtotal_highlighted?: boolean;
  rawDecklineData: EnhancedDeckline;
}

/**
 * Interface for column template and mapping group configuration
 * Used to define the template and mapping group for deck columns
 */
export interface ColumnTemplateMapping {
  column_template: string;
  column_mapping_group: string;
}
